import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface InfoTooltipProps {
  content: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  className?: string;
  iconClassName?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  content,
  side = 'top',
  sideOffset = 8,
  className = '',
  iconClassName = ''
}) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span className={`cursor-pointer ${className}`}>
            <Info className={`h-4 w-4 text-muted-foreground ${iconClassName}`} />
          </span>
        </TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset}>
          <p className="max-w-xs text-xs font-normal">
            {content}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
